import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { StorybookLibrary } from './pages/StorybookLibrary';
import { StorybookIntro } from './pages/StorybookIntro';
import { StorybookReader } from './pages/StorybookReader';

/**
 * Storybook Portal - Parent-facing storybook reading experience
 * 
 * Routes:
 * - /storybooks - Library of all accessible storybooks
 * - /storybooks/:slug - Intro page for a specific storybook
 * - /storybooks/:slug/read - Reader view for the storybook
 */
export const StorybookPortal: React.FC = () => {
  return (
    <Routes>
      <Route index element={<StorybookLibrary />} />
      <Route path=":slug" element={<StorybookIntro />} />
      <Route path=":slug/read" element={<StorybookReader />} />
      <Route path="*" element={<Navigate to="/storybooks" replace />} />
    </Routes>
  );
};

export default StorybookPortal;
